const encode = encodeURIComponent
const decode = decodeURIComponent

// 解析字符串为字典格式
export function resolveQuery(query,
                      extraQuery = {}) {
  query = query || window.location.href
  let parsedQuery = {}
  let index = query.indexOf('?')
  query = index !== -1 ? query.slice(query.indexOf('?') + 1) : ''
  query = query.replace(/(\?|#\/)/g, '&')
  try {
    parsedQuery = parseQuery(query)
  } catch (e) {
    parsedQuery = {}
  }
  for (const key in extraQuery) {
    parsedQuery[key] = extraQuery[key]
  }
  return parsedQuery
}

// 将字典格式拼接成字符串，带“?”
export function stringifyQuery(obj) {
  const res = obj ? Object.keys(obj).sort().map(key => {
    const val = obj[key]

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      const result = []
      val.slice().forEach(val2 => {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key))
        } else {
          result.push(encode(key) + '=' + encode(val2))
        }
      })
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(x => x.length > 0).join('&') : null
  return res ? `?${res}` : ''
}

export function parseQuery(query) {
  const res = {}

  query = query.trim().replace(/^(\?|#|&)/, '')

  if (!query) {
    return res
  }
  query.split('&').forEach(param => {
    const parts = param.replace(/\+/g, ' ').split('=')
    const key = decode(parts.shift())
    const val = parts.length > 0 ? decode(parts.join('=')) : ''

    if (key === '') {
      return false
    }
    if (res[key] === undefined) {
      res[key] = val
    } else if (Array.isArray(res[key])) {
      res[key].push(val)
    } else {
      res[key] = val
    }
  })

  return res
}

/**
 * 拼接当前location的query
 * @param url
 * @param json
 * @returns {string}
 */
export function concatLocalQuery(url = '', json = {}) {
  var objUrlQuery = resolveQuery(url)
  var objLocalQuery = resolveQuery(window.location.href)
  var newObjQuery = Object.assign({}, objUrlQuery, objLocalQuery, json)
  var strNewQuery = stringifyQuery(newObjQuery)
  var index = url.indexOf('?')
  return (index !== -1 ? url.slice(0, index) : url.slice(0)) + strNewQuery
}

export function parse(url = window.location.search) {
  const obj = {}
  const arr = url.match(new RegExp('[?&][^?&]+=[^?&]*', 'g'))
  if (arr) {
    arr.forEach((item) => {
      const pairs = item.substring(1).split('=')
      const key = decodeURIComponent(pairs[0])
      const val = decodeURIComponent(pairs[1])
      obj[key] = val
    })
  }
  return obj
}

export function stringify(urlP, paramsObj) {
  let url = urlP
  const paramsArr = []
  const paramKeys = Object.keys(paramsObj)
  paramKeys.forEach((param) => {
    paramsArr.push(
      `${param}=${encodeURIComponent(paramsObj[param])}`
    )
  })

  if (paramsArr.length > 0) {
    if (url.indexOf('?') > -1) {
      url += '&'
    } else {
      url += '?'
    }
    url += paramsArr.join('&')
  }

  return url
}

export default {
  parse,
  stringify,
  concatLocalQuery,
  parseQuery,
  stringifyQuery,
  resolveQuery
}
